import { ExperienceType } from '@/generated/graphql';

type ExperienceModalStep = {
  icon?: string;
  name?: string;
};

type ExperienceModalContent = {
  mainIcon?: string;
  heading?: string;
  detail?: string;
  steps?: ExperienceModalStep[];
};

export const modalExperiences: Record<
  Exclude<ExperienceType, ExperienceType.Undefined>,
  ExperienceModalContent
> = {
  [ExperienceType.Box]: {
    mainIcon: '/discover/experiences/mobile/box.png',
    heading: 'How do Curiko Box experiences work?',
    detail:
      'Curiko Box experiences come to your doorstep with all the materials you need to try something new. Take on projects at your own pace. Boxes are made with love by Hosts, and include personal recommendations to communities of interest.',
    steps: [
      {
        icon: '/discover/experiences/modal/laptop.png',
        name: 'Choose a Box to order',
      },
      {
        icon: '/discover/experiences/modal/stamp.png',
        name: 'Box arrives! Check it out',
      },
      {
        icon: '/discover/experiences/modal/box.png',
        name: 'Try with the videos attached ',
      },
      {
        icon: '/discover/experiences/modal/buble.png',
        name: 'Reflect on your experience',
      },
    ],
  },
  [ExperienceType.Video]: {
    mainIcon: '/discover/experiences/mobile/video.png',
    heading: 'How do Curiko Video experiences work?',
    detail:
      'Curiko Video experiences happen whenever you want. Get introduced to new subjects through the eyes of Hosts. Pause, skip, and rewatch as much as you’d like. Afterwards, follow-up with Hosts to find out more.',
    steps: [
      {
        icon: '/discover/experiences/modal/laptop.png',
        name: 'Choose a video experience',
      },
      {
        icon: '/discover/experiences/modal/screen.png',
        name: 'Watch the video at your own pace',
      },
      {
        icon: '/discover/experiences/modal/buble.png',
        name: 'Do the stretch challenges',
      },
      {
        icon: '/discover/experiences/modal/map.png',
        name: 'Reach out to the host to find a new community!',
      },
    ],
  },
  [ExperienceType.Event]: {
    mainIcon: '/discover/experiences/mobile/group.png',
    heading: 'How do Curiko Group experiences work?',
    detail: `Curiko Group experiences are lively spaces to connect with a host and other community members around a shared topic of interest. Hear different ideas and exchange thoughts.`,
    steps: [
      {
        icon: '/discover/experiences/modal/laptop.png',
        name: 'Book experience',
      },
      {
        icon: '/discover/experiences/modal/zoom.png',
        name: 'Do online experience',
      },
      {
        icon: '/discover/experiences/modal/buble.png',
        name: 'Reflect on your experience',
      },
    ],
  },
  [ExperienceType.Schedule]: {
    mainIcon: '/discover/experiences/mobile/one-on-one.png',
    heading: 'How do Curiko One-on-one experiences work?',
    detail: `Curiko One-on-one experiences enable you to meet individually with a Host to explore a passion or pursuit. You can ask questions, swap stories, and set the focus. Maybe groups aren't your thing, or you want to dive deep! `,
    steps: [
      {
        icon: '/discover/experiences/modal/laptop.png',
        name: 'Request 1:1 experience',
      },
      {
        icon: '/discover/experiences/modal/calendar.png',
        name: 'Host confirms the time',
      },
      {
        icon: '/discover/experiences/modal/zoom.png',
        name: 'Do online experience',
      },
      {
        icon: '/discover/experiences/modal/buble.png',
        name: 'Reflect on your experience',
      },
    ],
  },
};
